import React from "react";
import { Button } from "antd";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";

import { i18, trb } from "@utilities";
import { FullWidthInputWrapper } from "@components";

const ButtonGroup = Button.Group;

export const AddRemoveInputs = ({ totalInputsAdded, maxInputsAllowed = 1, onAdd, onRemove }) => {
  return (
    <FullWidthInputWrapper>
      <ButtonGroup className="w-100 justify-content-end pr-3">
        {totalInputsAdded > 1 && (
          <Button
            type="link"
            icon={<MinusCircleOutlined />}
            size="small"
            className="eb_kyc_button_remove"
            onClick={onRemove}
          >
            {trb(i18.Buttons.RemoveBlocks)}
          </Button>
        )}
        {totalInputsAdded !== maxInputsAllowed && (
          <Button
            type="link"
            icon={<PlusCircleOutlined />}
            size="small"
            className="eb_kyc_button_remove"
            onClick={onAdd}
          >
            {trb(i18.Buttons.DuplicateBlocks)}
          </Button>
        )}
      </ButtonGroup>
    </FullWidthInputWrapper>
  );
};
